<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Grupno dodavanje korisnika blagajne</h2>
      <h6>
        Ovde možete dodati korisnike aplikacije kao korisnike blagajne. Ukoliko
        želite da dodelite više posebnih delova jednom članu to morate uraditi u
        formi za kreiranje novog korisnika blagajne.
      </h6>
    </div>
    <div class="body"></div>
    <mini-table
      :data="members"
      :height="320"
      :checkable="true"
      :loading="isLoading"
    ></mini-table>
    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons-select-all" style="text-align:center">
        <button type="submit" class="btn btn-primary" @click="selectAll">
          Izaberi sve
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="deselectAll"
        >
          Poništi izbor
        </button>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="addVirtualMembers"
        >
          <p v-if="!loading">Dodaj korisnike blagajne</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import { ModelSelect } from 'vue-search-select';
import miniTable from '../ModalBulkAddVirtualMembersTable';
import { utilService } from '@/util/UtilService.js';

import axios from '@/axios/axios.js';

export default {
  components: {
    miniTable
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      members: [],
      isLoading: true,
      loading: false,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  computed: {
    options() {
      let members = [];
      members.push({
        value: null,
        text: 'Bez izabranog stanara'
      });
      let realMembers = this.members.map(e => {
        return { value: e.id, text: `${e.user_full_name} - ${e.email}` };
      });
      members.push(...realMembers);
      return members;
    }
  },
  watch: {
    selectedMember: function() {
      this.updateMemberFields();
    }
  },
  async created() {
    axios
      .post('member/get-members-by-community', {
        community_id: this.$route.params.id,
        active: 1
      })
      .then(({ data }) => {
        for (let i = 0; i < data.length; i++) {
          data[i].ordinal = i + 1;
          data[i].checked = true;
        }
        this.members = data;
        this.isLoading = false;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', ['getAllMembersForCommunityFinances']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations('finances', ['setVirtualMembersList']),
    selectAll() {
      for (let member of this.members) {
        member.checked = true;
      }
    },
    deselectAll() {
      for (let member of this.members) {
        member.checked = false;
      }
    },
    updateMemberFields() {
      this.members.forEach(e => {
        if (e.id === this.selectedMember) {
          this.fullName = e.user_full_name;
          this.divDescription = e.div_desc;
          this.email = e.email;
        }
      });
    },
    addVirtualMembers() {
      this.errorOccurred = false;
      let selectedMembers = this.members.filter(m => m.checked === true);
      if (!this.validateInput(selectedMembers)) {
        this.errorOccurred = true;
        return;
      }

      this.loading = true;
      selectedMembers = selectedMembers.map(member => {
        const newBalance = parseFloat(
          parseFloat(member.balance.replace(/,/g, '')).toFixed(2)
        );
        return {
          fullName: member.user_full_name,
          email: member.email,
          divDescriptions: [member.div_desc],
          memberId: member.id,
          balance: newBalance
        };
      });
      financesInstance
        .post(`communities/${this.$route.params.id}/members`, {
          members: selectedMembers
        })
        .then(async () => {
          const virtualMembers = await this.getAllMembersForCommunityFinances(
            this.$route.params.id
          );
          this.setVirtualMembersList(virtualMembers);
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.showFailModal();
        });
    },
    validateInput(selectedMembers) {
      if (!selectedMembers || selectedMembers.length == 0) {
        this.errorMessage = 'Morate izabrati bar jednog korisnika';
        return false;
      }
      if (selectedMembers.find(d => !d.div_desc || d.div_desc === '')) {
        this.errorMessage = 'Morate popuniti sva polja za opis posebnog dela';
        return false;
      }
      if (selectedMembers.find(d => d.div_desc.length > 250)) {
        this.errorMessage =
          'Sva polja za opis posebnog dela mogu imati najviše 250 karaktera';
        return false;
      }
      if (selectedMembers.find(d => !d.email || d.email === '')) {
        this.errorMessage = 'Morate popuniti sva polja za email';
        return false;
      }
      if (selectedMembers.find(d => !utilService.isEmailValid(d.email))) {
        this.errorMessage = 'Sva polja za email moraju biti validna';
        return false;
      }
      if (selectedMembers.find(d => d.email.length > 250)) {
        this.errorMessage =
          'Sva polja za email mogu imati najviše 250 karaktera';
        return false;
      }
      if (selectedMembers.find(d => !d.balance || d.balance === '')) {
        this.errorMessage = 'Morate popuniti sva polja za početno stanje';
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
.cb-container {
  margin-bottom: 0 !important;
}
.modal-header {
  display: inline-block;
}
.modal-content-virtual-member {
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;

    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons-select-all {
    display: inline-flex;
    float: left;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }
}
</style>
